import FeedSangjoJoinContainer from "@/containers/Content/FeedSangjoJoinContainer";
import { GetStaticProps } from "next";

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {
      pageOgTitle: "상조 서비스 가이드 | 종류, 가격, 가입 전 체크할 점 | 고이",
      pageDescription:
        "상조 서비스가 무엇인지부터 선불제와 후불제의 차이, 가입 전 확인해야 할 점까지 정리했습니다.",
      pageOgDescription:
        "상조 서비스가 무엇인지부터 선불제와 후불제의 차이, 가입 전 확인해야 할 점까지 정리했습니다.",
      pageKeywords:
        "상조, 상조 서비스, 상조 비교, 선불제 상조, 100원 상조, 고이 프라임",
    },
  };
};

export default function SangjoJoin() {
  return <FeedSangjoJoinContainer />;
}
